export const MAXIMUM_SIZE_OF_MESSAGE = 4000;
export const MAXIMUM_SIZE_OF_FILES = 786432000;
export const MAXIMUM_NUMBER_OF_FILES = 5;
